import { ApplicationState } from "..";
import { Notification, IncomingMessageNotification, IncomingMessagesSummary, CommunicationQuotas } from "../../models";

export const getNotifications = (state: ApplicationState): Notification[] => state.general?.notifications ?? [];
export const getTasksUpdatedAt = (state: ApplicationState): number => state.general?.tasksUpdatedAt ?? 0;

export const getSelectedBranch = (state: ApplicationState): string | undefined => state.general?.branchSelected;

export const getMessagesMenu = (state: ApplicationState): IncomingMessagesSummary => state.general?.messagesMenu ?? {
    unreadMessages: [],
    recentMessages: [],
};
export const getUnreadMessages = (state: ApplicationState): IncomingMessageNotification[] => state.general?.messagesMenu?.unreadMessages ?? [];
export const getRecentMessages = (state: ApplicationState): IncomingMessageNotification[] => state.general?.messagesMenu?.recentMessages ?? [];
export const getCommunicationQuotas = (state: ApplicationState): CommunicationQuotas | undefined => state.general?.communicationQuotas;
export const getCommunicationQuotasFetchedAt = (state: ApplicationState): number | undefined => state.general?.communicationQuotasFetchedAt;

export const getSelectedCashRegisterName = (state: ApplicationState): string | undefined => state.general?.selectedCashRegisterName;
